var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCorrectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 161.79 161.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #4ade80;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9",
    "data-name": "Layer 9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 161.79,
    height: 161.79,
    rx: 27.62,
    ry: 27.62
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M131.38,43.9l-3.7-3.7c-3.69-3.69-9.66-3.69-13.35,0l-53.96,53.96-12.91-12.91c-3.69-3.69-9.66-3.69-13.35,0l-3.7,3.7c-3.69,3.69-3.69,9.66,0,13.35l23.28,23.28c.69,.69,1.46,1.25,2.29,1.68,3.56,1.87,8.07,1.31,11.06-1.68l3.7-3.7,60.64-60.64c3.69-3.69,3.69-9.66,0-13.35Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrectIcon);
export default __webpack_public_path__ + "static/media/CorrectIcon.7765e2643a18aa0299d49ca04248698b.svg";
export { ForwardRef as ReactComponent };